export default "__VITE_ASSET__BXwvLorR__";